import clsx from "clsx";
import { NavLink } from "react-router-dom";

interface NavButtonProps {
    link: string;
    name: string;
}

const NavButton = ({ link, name }: NavButtonProps) => {
    return (
        <NavLink
            to={link}
            className={(active) =>
                clsx([
                    "flex items-center rounded-full p-2 text-black font-medium h-[38px] shrink-0",
                    "hover:bg-primary-600 hover:text-white",
                    active.isActive && "bg-primary-500 text-white",
                ])
            }
        >
            <span className="mx-2">{name}</span>
        </NavLink>
    );
};

export default NavButton;
